import i18n from "@/services/i18n";

const financeData = {
    // АКТИВ
    // ************************

    // ВНЕОБОРОТНЫЕ АКТИВЫ
    1110: i18n.t('utilsData.finance.1110'),
    1120: i18n.t('utilsData.finance.1120'),
    1130: i18n.t('utilsData.finance.1130'),
    1140: i18n.t('utilsData.finance.1140'),
    1150: i18n.t('utilsData.finance.1150'),
    1160: i18n.t('utilsData.finance.1160'),
    1170: i18n.t('utilsData.finance.1170'),
    1180: i18n.t('utilsData.finance.1180'),
    1190: i18n.t('utilsData.finance.1190'),

    // ОБОРОТНЫЕ АКТИВЫ
    1210: i18n.t('utilsData.finance.1210'),
    1220: i18n.t('utilsData.finance.1220'),
    1230: i18n.t('utilsData.finance.1230'),
    1240: i18n.t('utilsData.finance.1240'),
    1250: i18n.t('utilsData.finance.1250'),
    1260: i18n.t('utilsData.finance.1260'),

    // ПАССИВ
    // ************************

    // КАПИТАЛ И РЕЗЕРВЫ
    1310: i18n.t('utilsData.finance.1310'),
    1320: i18n.t('utilsData.finance.1320'),
    1340: i18n.t('utilsData.finance.1340'),
    1350: i18n.t('utilsData.finance.1350'),
    1360: i18n.t('utilsData.finance.1360'),
    1370: i18n.t('utilsData.finance.1370'),

    // ДОЛГОСРОЧНЫЕ ОБЯЗАТЕЛЬСТВА
    1410: i18n.t('utilsData.finance.1410'),
    1420: i18n.t('utilsData.finance.1420'),
    1430: i18n.t('utilsData.finance.1430'),
    1450: i18n.t('utilsData.finance.1450'),

    // КРАТКОСРОЧНЫЕ ОБЯЗАТЕЛЬСТВА
    1510: i18n.t('utilsData.finance.1510'),
    1520: i18n.t('utilsData.finance.1520'),
    1530: i18n.t('utilsData.finance.1530'),
    1540: i18n.t('utilsData.finance.1540'),
    1550: i18n.t('utilsData.finance.1550'),

    // ************************
    // ФОРМА 2
    // ************************

    2110: i18n.t('utilsData.finance.2110'),
    2120: i18n.t('utilsData.finance.2120'),
    2100: i18n.t('utilsData.finance.2100'),
    2210: i18n.t('utilsData.finance.2210'),
    2220: i18n.t('utilsData.finance.2220'),
    2200: i18n.t('utilsData.finance.2200'),
    2310: i18n.t('utilsData.finance.2310'),
    2320: i18n.t('utilsData.finance.2320'),
    2330: i18n.t('utilsData.finance.2330'),
    2340: i18n.t('utilsData.finance.2340'),
    2350: i18n.t('utilsData.finance.2350'),
    2300: i18n.t('utilsData.finance.2300'),
    2410: i18n.t('utilsData.finance.2410'),
    2421: i18n.t('utilsData.finance.2421'),
    2430: i18n.t('utilsData.finance.2430'),
    2450: i18n.t('utilsData.finance.2450'),
    2460: i18n.t('utilsData.finance.2460'),
    2400: i18n.t('utilsData.finance.2400'),
    2510: i18n.t('utilsData.finance.2510'),
    2520: i18n.t('utilsData.finance.2520'),
    2500: i18n.t('utilsData.finance.2500'),
    2900: i18n.t('utilsData.finance.2900'),
    2910: i18n.t('utilsData.finance.2910'),
};

const getFinanceName = (id) => {
    if (financeData[id] !== undefined) {
        return financeData[id];
    }
    return "NO DATA";
};

export default getFinanceName;
